
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android-app-development",
      function () {
        return require("private-next-pages/android-app-development/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android-app-development"])
      });
    }
  